<template>
  <div class="note-list">
    <span
      v-for="(note, idx) in noteList"
      :key="`note-${idx}`"
      class="note-list__item my-0 p-2 border-b first:border-t border-gray-300 hover:bg-gray-200 relative"
    >
      <div class="title w-4/5 flex items-center">
        <span class="font-semibold ml-2 mr-1">{{ idx + 1 }}. </span>
        <input
          :value="note"
          class="w-full"
          @keyup.enter="updateNote($event.target.value, idx)"
          @blur="resetDefaultNote($event.target, idx)"
        />
      </div>

      <md-button
        class="ml-2 md-simple md-just-icon md-icon-button md-danger"
        @click.native.prevent="() => confirmDeleteNote(idx)"
      >
        <md-icon>delete_forever</md-icon>
      </md-button>
    </span>

    <span
      class="note-list__item my-0 p-2 border-b first:border-t border-gray-300 hover:bg-gray-200"
      v-if="showAddNote"
    >
      <input
        v-model="additionalNote"
        class="w-4/5"
        @keyup.enter="addNewNote"
        @blur="closeAddNote"
      />
    </span>

    <div
      class="note-list__add-btn text-gray-400 font-medium bg-transparent duration-150 hover:bg-gray-200 mt-2 ml-2 rounded-md"
      @click="triggerShow"
    >
      <md-icon class="duration-150">add</md-icon>
      <span>{{ $t("change_password.add_note") }}</span>
    </div>
  </div>
</template>

<script>
import { Message } from "@/helpers/utils";
import Swal from "sweetalert2";
import cloneDeep from "lodash/cloneDeep";

export default {
  props: ["list", "updateNoteFunc"],
  data() {
    return {
      defaultNote: [],
      noteList: [],
      additionalNote: "",
      showAddNote: false
    };
  },

  watch: {
    list: function(newVal) {
      this.noteList = newVal;
      this.defaultNote = cloneDeep(newVal);
    }
  },

  methods: {
    resetDefaultNote(target, index) {
      target.value = this.defaultNote[index];
    },

    async updateNote(value, index) {
      this.noteList[index] = value;
      try {
        await this.updateNewNoteList(this.noteList);
        Message.success("Update note successfully!");
        this.defaultNote = this.noteList;
      } catch (error) {
        Message.error("Update note failed!");
      }
    },

    async addNewNote() {
      try {
        const newList = [...this.noteList, this.additionalNote];
        await this.updateNewNoteList(newList);
        Message.success(`Create new note successfully!`);
        this.closeAddNote();
      } catch (error) {
        Message.error(`Create new note failed!`);
      }
    },

    closeAddNote() {
      this.showAddNote = false;
      this.additionalNote = "";
    },

    triggerShow() {
      this.showAddNote = true;
    },

    confirmDeleteNote(idx) {
      Swal.fire({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.deleteNote(idx);
        }
      });
    },

    async deleteNote(idx) {
      const newList = [
        ...this.noteList.slice(0, idx),
        ...this.noteList.slice(idx + 1)
      ];
      try {
        await this.updateNewNoteList(newList);
        Message.success(`Delete note successfully!`);
      } catch (error) {
        Message.error(`Delete note failed!`);
      }
    },

    updateNewNoteList(newList) {
      return this.updateNoteFunc({
        notes: newList
      }).then(data => {
        this.noteList = data.notes.slice(0);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.note-list {
  max-height: 500px;
  overflow-y: auto;

  &__item {
    display: flex;
    align-items: center;

    input {
      overflow: hidden;
      text-overflow: ellipsis;
      border-radius: 6px;
      padding: 0.5rem;
    }
  }
  &__add-btn {
    display: inline-flex;
    align-items: center;

    font-size: 14px;
    height: 28px;
    line-height: 28px;

    padding: 0 8px 0 0;
    & > * {
      line-height: 28px !important;
    }
    &:hover > * {
      @apply text-gray-800;
    }

    i {
      margin: 0;
      font-size: 17px !important;
      font-weight: 700;
    }
  }
}
</style>
